module.exports = __webpack_public_path__ + "images/package-ff9eb72c01531c46f6a2c2a5fbcb975c.png";